export const CANCEL_REQUEST = "/public/cancel-appointment-request-rev1";
export const CANCEL_CONFIRM = "/doctor/cancel-appointment-confirmation-rev1";
